// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-menu-trigger {
  margin: -16px;
  padding: 16px;
  width: calc(100% + 32px);
}

.column-menu .ant-dropdown-menu {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  min-width: 180px;
}

.column-menu .ant-dropdown-menu-item {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.column-menu .ant-dropdown-menu-item .ant-dropdown-menu-item-icon {
  margin-right: 0.5rem;
}

.column-menu .ant-dropdown-menu-item-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.column-menu-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0.75rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 260px;
}

.checkbox-filter-options {
  display: flex;
  max-height: 16rem;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.checkbox-filter-options .ant-checkbox-wrapper {
  margin: 0px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.column-menu-panel .ant-picker-cell-range-start .ant-picker-cell-inner,
.column-menu-panel .ant-picker-cell-range-end .ant-picker-cell-inner {
  border-radius: 9999px;
}
.column-menu-panel .ant-picker-cell-in-range::before,
.column-menu-panel .ant-picker-cell-range-start::before,
.column-menu-panel .ant-picker-cell-range-end::before {
  --tw-bg-opacity: 1;
  background-color: rgb(233 240 247 / var(--tw-bg-opacity, 1));
}
.column-menu-panel .ant-picker-cell-disabled .ant-picker-cell-inner {
  --tw-text-opacity: 1;
  color: rgb(205 50 69 / var(--tw-text-opacity, 1));
}
.column-menu-panel .ant-picker-cell-disabled::before {
  background-color: transparent;
}
.column-menu-panel .ant-picker-cell-today .ant-picker-cell-inner::before {
  border-radius: 9999px;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.column-menu-panel .ant-picker-cell-range-start .ant-picker-cell-inner,
.column-menu-panel .ant-picker-cell-range-end .ant-picker-cell-inner {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}`, "",{"version":3,"sources":["webpack://./src/components/Table/ColumnMenu.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,aAAA;EACA,wBAAA;AANF;;AAUE;EAAA,oBAAA;EAAA,uBAAA;EACA;AADA;;AAKA;EAAA,qBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,4DAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,aAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,YAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;EACA;AADA;;AAKA;EAAA,aAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,sBAAA;EAAA,WAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;AAGE;EAAA,WAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA;AAAA;;AAQA;;EAAA;AAAA;AAMA;;;EAAA,kBAAA;EAAA;AAAA;AAMA;EAAA,oBAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA,qBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAKA;;EAAA,oBAAA;EAAA;AAAA","sourcesContent":["// Antd pads the header cell itself (16px a side), so the trigger is inset from the cell\n// edges by default. Cancel that padding with a negative margin and re-apply it on the\n// button so the clickable area covers the whole cell.\n//\n// Values are literal rather than a SCSS variable on purpose: interpolating one into\n// calc() emits a source map entry with a null original column, which resolve-url-loader\n// rejects with \"Invalid mapping\" and fails the production build.\n.column-menu-trigger {\n  margin: -16px;\n  padding: 16px;\n  width: calc(100% + 32px);\n}\n\n.column-menu .ant-dropdown-menu {\n  @apply py-1;\n  min-width: 180px;\n}\n\n.column-menu .ant-dropdown-menu-item {\n  @apply text-sm text-gray-700 font-medium px-3 py-2;\n}\n\n.column-menu .ant-dropdown-menu-item .ant-dropdown-menu-item-icon {\n  @apply mr-2;\n}\n\n.column-menu .ant-dropdown-menu-item-selected {\n  @apply bg-gray-100 text-gray-900;\n}\n\n.column-menu-panel {\n  @apply flex flex-col items-start gap-1 rounded-lg bg-white p-3 shadow-lg;\n  width: 260px;\n}\n\n.checkbox-filter-options {\n  @apply flex max-h-64 w-full flex-col gap-2 overflow-y-auto py-1;\n\n  .ant-checkbox-wrapper {\n    @apply m-0 text-sm text-gray-700;\n  }\n}\n\n// Round the ends of the selected range and soften the band between them.\n.column-menu-panel {\n  .ant-picker-cell-range-start .ant-picker-cell-inner,\n  .ant-picker-cell-range-end .ant-picker-cell-inner {\n    @apply rounded-full;\n  }\n\n  .ant-picker-cell-in-range::before,\n  .ant-picker-cell-range-start::before,\n  .ant-picker-cell-range-end::before {\n    @apply bg-primary-50;\n  }\n\n  // Future dates can't be a \"last updated\" date, so they are disabled and called out\n  // in red rather than the usual muted grey.\n  .ant-picker-cell-disabled .ant-picker-cell-inner {\n    @apply text-error-500;\n  }\n\n  .ant-picker-cell-disabled::before {\n    @apply bg-transparent;\n  }\n\n  .ant-picker-cell-today .ant-picker-cell-inner::before {\n    @apply rounded-full border-none bg-gray-100;\n  }\n\n  .ant-picker-cell-range-start .ant-picker-cell-inner,\n  .ant-picker-cell-range-end .ant-picker-cell-inner {\n    @apply text-white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
